import UploadImgIcon from '../../../../assets/svg/upload-img.svg?react';
import UploadCircleIcon from '../../../../assets/svg/upload-circle.svg?react';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJLoading from '../../../../common/components/FJLoading/FJLoading';
import FJIconButton from '../../../../common/components/FJIconButton/FJIconButton';
import styles from './FJFake3dInput.module.less';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FJConstant from '../../../../constants/FJConstant';
import FJPreviewBox from '../../../../common/components/FJPreviewBox/FJPreviewBox';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip';
import ReUploadIcon from '../../../../assets/svg/re-upload.svg?react';
import AddFileWhiteIcon from '../../../../assets/svg/add-file-white.svg?react';
import UploadBorder265Icon from '../../../../assets/svg/upload-border-265.svg?react';
import UploadBorder265HoverIcon from '../../../../assets/svg/upload-border-265-hover.svg?react';
import UploadBorder80Icon from '../../../../assets/svg/upload-border-80.svg?react';
import UploadBorder80HoverIcon from '../../../../assets/svg/upload-border-80-hover.svg?react';
import FJTextWithEllipsisParent from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsisParent';
import FJUtil from '../../../../util/FJUtil';
import FJEvent from '../../../../store/FJEvent.js';

import FJFileUpload from '../../../../common/components/FJFileUpload/FJFileUpload';
const FJFake3dInput = props => {
    const {
        uploadImg,
        uploadStatus = FJConstant.DEFAULT,
        isSmallComponent = false,
        originImage = {},
        previewImage = {},
        cancelDepthMapTask,
        isDraggingFile,
        setIsDraggingFile,
        openMediaLibrary,
    } = props;
    const _onUploadImg = async file => {
        const spaceType = await FJUtil.checkUserSpace();
        if (spaceType > 0) {
            FJEvent.dispatch(FJConstant.USER_SPACE_CHANGE, spaceType);
            return;
        }
        uploadImg(file);
    };

    const _onDragOver = e => {
        setIsDraggingFile(true);
        e.stopPropagation();
        e.preventDefault();
    };

    const _onDragLeave = e => {
        setIsDraggingFile(false);
        e.stopPropagation();
        e.preventDefault();
    };

    const _onDragDrop = e => {
        setIsDraggingFile(false);
        e.stopPropagation();
        e.preventDefault();
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            _onUploadImg(file);
        }
    };
    const _onCancel = e => {
        e.preventDefault();
        e.stopPropagation();
        cancelDepthMapTask && cancelDepthMapTask();
    };
    const renderEmptyUpload = () => {
        if (isSmallComponent) {
            return (
                <>
                    <UploadCircleIcon />
                    <div className={styles.upload_text}>{FJLocalStore._('upload-image')}</div>
                    {renderBorder()}
                </>
            );
        }
        return (
            <>
                <UploadImgIcon className={styles.upload_img} />
                <div className={styles.text}>{FJLocalStore._('upload-an-image-to-generate-3d-animation')}</div>
                <FJFileUpload
                    onUpload={_onUploadImg}
                    onClick={window.isEditPage && openMediaLibrary ? openMediaLibrary : undefined}
                >
                    <FJIconButton className={styles.btn} type={'gradient'} text={FJLocalStore._('upload-image')} />
                </FJFileUpload>
                {renderBorder()}
            </>
        );
    };
    const renderGenerating = () => {
        return (
            <>
                <div className={styles.preview_box}>
                    <img src={previewImage.src} loading='lazy' className={styles.preview_img} />
                    <div className={styles.loading}>
                        <FJLoading />
                    </div>
                </div>
                <div className={styles.generating_text}>{FJLocalStore._('processing')}</div>
                <div className={styles.cancel} onClick={_onCancel}>
                    {FJLocalStore._('cancel')}
                </div>
                {renderBorder()}
            </>
        );
    };

    const renderBorder = () => {
        return (
            <div className={styles.upload_border_box}>
                {isSmallComponent ? (
                    <>
                        <UploadBorder80Icon className={styles.upload_border} />
                        <UploadBorder80HoverIcon className={styles.upload_border_hover} />
                    </>
                ) : (
                    <>
                        <UploadBorder265Icon className={styles.upload_border} />
                        <UploadBorder265HoverIcon className={styles.upload_border_hover} />
                    </>
                )}
            </div>
        );
    };
    const renderSuccess = () => {
        return (
            <>
                <div className={styles.img_box}>
                    <img className={styles.img} src={originImage.src} alt='' loading='lazy' />
                    <FJPreviewBox imageInfo={originImage} className={styles.mask} />
                </div>
                <div className={styles.img_info}>
                    <FJTextWithEllipsisParent
                        className={styles.img_info_title}
                        text={originImage.name || FJLocalStore._('image')}
                    />
                </div>
                <FJToolTip title={FJLocalStore._('change-image')}>
                    <FJFileUpload
                        className={styles.reload_icon}
                        onUpload={_onUploadImg}
                        onClick={window.isEditPage && openMediaLibrary ? openMediaLibrary : undefined}
                    >
                        <ReUploadIcon />
                    </FJFileUpload>
                </FJToolTip>
                {isDraggingFile && (
                    <div className={classNames(styles.filter_mask, isDraggingFile ? styles.dragging : '')}>
                        <AddFileWhiteIcon />
                        <span className={styles.filter_mask_text}>{FJLocalStore._('drag-and-drop')}</span>
                    </div>
                )}
                <div className={styles.dragging_mask}></div>
            </>
        );
    };
    const renderMain = () => {
        switch (uploadStatus) {
            case FJConstant.DEFAULT:
                return renderEmptyUpload();
            case FJConstant.SUCCESS:
                return renderSuccess();
            default:
                return renderGenerating();
        }
    };

    return (
        <div
            className={classNames(
                styles.box,
                isDraggingFile && styles.dragging,
                isSmallComponent && styles.small,
                uploadStatus === FJConstant.SUCCESS && styles.success,
            )}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
        >
            {renderMain()}
        </div>
    );
};

FJFake3dInput.propTypes = {
    uploadImg: PropTypes.func,
    isLoading: PropTypes.bool,
    isUploading: PropTypes.bool,
    uploadStatus: PropTypes.string,
    isSmallComponent: PropTypes.bool,
    originImage: PropTypes.object,
    cancelDepthMapTask: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    previewImage: PropTypes.object,
    openMediaLibrary: PropTypes.func,
};

export default FJFake3dInput;
